import { useEffect, useRef, useState } from "react";
import { postData } from "../../ApiServices/ApiService";
import { ORG_EMP_SEARCH_TO_ADD_TEAMMEMBER,ORG_EXPENSE_LIST_FILTER } from "../../ApiServices/BaseURL";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";
import { useNavigate } from 'react-router-dom';

const ExpenseApprovalsController = (expenseApproveList,onRefresh, fetchExpenseApprove) => {
  const pageName = "ExpenseApprovalsController";
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState({
    employee: "",
    date: "",
    amount: "",
    status: null,
    emp_id: null,

  });
  const { setIsLoginPopup } = useTheme();
  const [filterError,setFilterError] = useState('')
  const [expenseListError, setExpenseListError] = useState('');

  const [filteredExpenses, setFilteredExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRefs = useRef({});
  const searchListRef = useRef(null);
  const expenseInfoRef = useRef(null);
  const [employeeList, setEmployeeList] = useState([]);
const [employeeLoading, setEmployeeLoading] = useState(false);
const [employeeError, setEmployeeError] = useState("");

const [currentPage, setCurrentPage] = useState(1);

const [filterLength, setFilterLength] = useState(0);

  const statusOptions = [
    { label: "Approval Pending", value: "1" },
    { label: "Approved", value: "2" },
    { label: "Partially Approved", value: "4" },
    { label: "Rejected", value: "3" },
  ];

  const navigate = useNavigate();

  useEffect(()=>{
    console.log('expenseApproveList')
    if(expenseApproveList){
      setFilteredExpenses(expenseApproveList)
    }
  },[expenseApproveList])

  
  useEffect(() => {
      setFilterLength(0);
  }, []);

  const handleChange = (name, value) => {
    setFilters((prev) => {
      // If user manually changes the employee name, reset employee_id
      if (name === "employee") {
        return { ...prev, employee: value, emp_id: null };
      }
      return { ...prev, [name]: value };
    });
  };
  

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  const applyFiltersApproveList = async () => {
    setFilterError(""); // Clear any previous error
    setExpenseListError('');
    const { employee, ...restFilters } = filters;

    const isAnyFilterApplied = Object.values(restFilters).some(
      (val) => val !== null && val !== undefined && String(val).trim() !== ""
    );
  
    if (!isAnyFilterApplied) {
      setFilterError("Please apply at least one filter to proceed.");
      return;
    }
  
    setFilteredExpenses([]);
    setLoading(true);
    setCurrentPage(1);
    try {
      const payload = {
        emp_id_auth: storedUserId,
        action_code: "Approval_Filter",
        employee_id: filters.emp_id,
        expense_date: filters.date,
        amount: filters.amount,
        status: filters.status?.value,
      }
      const response = await postData(ORG_EXPENSE_LIST_FILTER, payload);
      const responseData = await response.json();
      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            setFilterLength(responseData?.dataJ?.length);
            setFilteredExpenses(responseData?.dataJ || []);
          } else {
            setExpenseListError(responseData?.info || "Failed to fetch expenses.");
            //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || '');

          }
        } else {
          setExpenseListError(responseData?.info || "Failed to fetch expenses.");
          //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setExpenseListError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || response || '');
               
        } else {
        setExpenseListError(responseData?.info || "Failed to fetch expenses.");
        //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || response || '');
      }
    } catch (err) {
      setExpenseListError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchFilterExpensesList-catch", err || '');
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setFilterError('')
    setExpenseListError('')
    setFilters({ employee: "", date: "", amount: "", status: null, emp_id: null, });
    setFilteredExpenses([]);
    fetchExpenseApprove();
    setEmployeeList([]);
    setFilterLength(0);
  };

  const handleApproveReject = (expenseData) => {
    // TODO: Trigger modal or approval/rejection logic
    expenseInfoRef.current = {
        ...expenseData,
        pageType: 'approve'
      };
      setShowModal(true);
    console.log("Handle Approve/Reject", expenseData);
  };

  const handleViewExpense = (expenseData) => {
    expenseInfoRef.current = {
      ...expenseData,
      pageType: 'view'
    };
    setShowModal(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
      if (searchListRef.current && !searchListRef.current.contains(event.target)) {
        // Click outside detected: clear the employeeList
        setEmployeeList([]);  // Clear list 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
const handleShowApprovedList =()=>{
    navigate("/status-list", {
    state: {
        title: 'Expense wise Reports',
        report_key: 'approved_expenses',
        heading: 'Approved Expenses',
        action_type: 'approved_expenses',
        selectedYear: {label:"2025-26",value:"2025-26"},
    }
    });
}

const handleSearchEmployee = async () => {
    setEmployeeLoading(true);
    setEmployeeError("");
    setEmployeeList([]);
  
    const query = filters.employee.trim();
    if (!query) {
      setEmployeeError("Please enter a name to search.");
      setEmployeeLoading(false);
      return;
    }
  
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
      const payload = {
        emp_id_auth: storedUserInfo?.emp_id,
        search_type: "GENERIC",
        search_word: query,
      };
  
      const response = await postData(ORG_EMP_SEARCH_TO_ADD_TEAMMEMBER, payload);
      const responseData = await response.json();
  
      if (response.status === 200 && responseData.statusCode === 200) {
        setEmployeeList(responseData?.dataJ || []);
        if (responseData?.dataJ?.length === 0) {
          setEmployeeError("No employees found.");
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setEmployeeError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
     } else {
        setEmployeeError(responseData?.info || "Failed to fetch employees.");
      }
    } catch (err) {
      setEmployeeError("Search failed. Try again.");
    } finally {
      setEmployeeLoading(false);
    }
  };
  
  const handleSelectEmployee = (employee) => {
    setFilters((prev) => ({
      ...prev,
      employee: employee?.emp_name || "",
      emp_id: employee?.emp_id || null,
    }));
    setEmployeeList([]);
  };

    // Pagination logic
    const itemsPerPage = 5;
    const totalPages = Math.ceil(filteredExpenses.length / itemsPerPage);
  
    const currentExpenses = filteredExpenses.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handlePageChange = (page) => {
      if (page >= 1 && page <= totalPages) {
        setCurrentPage(page);
      }
    };
  
    const getVisiblePages = () => {
      const maxPages = 3;
      const start = Math.max(1, currentPage - 1);
      const end = Math.min(totalPages, start + maxPages - 1);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };
  
    const visiblePages = getVisiblePages();

    const filterOnRefresh = () => {
      if (filterLength === 0 || filterLength === 1) {
          onRefresh();
          setFilterError('')
          setExpenseListError('')
          setFilters({ employee: "", date: "", amount: "", status: null, emp_id: null, });
          setFilteredExpenses([]);
          setEmployeeList([]);
          setFilterLength(0);
      } else {
          applyFiltersApproveList();
      }
    }

  return {
    showModal,
    closeModal: () => setShowModal(false),
    expenseInfoRef,
    filters,
    setFilters,
    handleChange,
    applyFiltersApproveList,
    resetFilters,
    dropdownRefs,
    openDropdown,
    toggleDropdown,
    statusOptions,
    handlePageChange,
    filteredExpenses: currentExpenses,
    currentPage,
    totalPages,
    visiblePages,
    loading,
    handleSearchEmployee,
    handleSelectEmployee,
    employeeList,searchListRef,
    employeeLoading,
    employeeError,filterError,
    handleApproveReject,handleShowApprovedList,
    expenseListError,
    handleViewExpense,
    filterLength,
    filterOnRefresh,
  };
};

export default ExpenseApprovalsController;
